import styled from 'styled-components';
import { Product } from '../../interfaces/Product';
import { Colors } from '../../styles/colors';
import React from 'react';
import { parseProductColorSetGradient } from './products/icons/ProductIconWrapper';

export const PanelWithGradient = styled.div<{ product?: Product }>`
  padding: 2rem;
  color: ${Colors.white};
  background: ${({ product }) => parseProductColorSetGradient(product?.metaProduct?.colorSet)};
`;

export const PanelWithGradientGreen = styled(PanelWithGradient)`
  background: linear-gradient(to top right, ${Colors.secondary}, #657F32);
`;

export const PanelWithGradientRed = styled(PanelWithGradient)`
  background: linear-gradient(to top right, #B54F0F, #9D3E0B);
`;
